import React from 'react';
import { useSelector } from "react-redux";



var checkText = 'check';

const ImageViewer = () => {
    var imageView = useSelector(state => state.image);
    return(
    
   <img style={{height:'50%'}} src={imageView} />
)
}
 
export default ImageViewer;